/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerConnection', [
    '$rootScope',
    '$timeout',
    'DesignerBase',

    function ($rootScope, $timeout, DesignerBase) {
      function DesignerConnection(data) {
        this.id = null;
        this.type = null;
        this.name = null;

        if (data) this.setData(data);
      }

      DesignerConnection.prototype = new DesignerBase();

      DesignerConnection.prototype.setData = function (data) {
        if (!data) {
          delete this.id;
          delete this.type;
          return;
        }

        this.id = data.id;
        this.type = data.type;
        this.name = data.name;
      };

      DesignerConnection.prototype.getData = function () {
        if (this.id && this.type) {
          return {
            id: this.id,
            type: this.type,
            name: this.name,
          };
        }
        return {};
      };

      DesignerConnection.prototype.isValid = function () {
        return this.id !== null && this.id !== '' && this.type !== null && this.type !== '';
      };

      return DesignerConnection;
    },
  ]);
})(window.angular);
